import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";

const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div<{ hasPadding?: boolean }>`
  display: flex;
  padding: ${({ hasPadding, theme }) => hasPadding && theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: ${({ hasPadding, theme }) =>
      hasPadding && `${theme.space["space-3"]}`};
    padding-left: 0;
  }
`;

export const Column = styled.div<{ grow?: boolean }>`
  ${flexColumn};
  ${({ grow }) =>
    grow
      ? css`
          flex: 1;
          width: 100%;
        `
      : css`
          flex-grow: 0;
        `}
`;

export const TextContainer = styled.div`
  ${flexColumn};
  flex: 1;
  margin: 0 ${({ theme }) => theme.space["space-4"]};
  align-items: flex-start;

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: center;
    padding: ${({ theme }) => theme.space["space-1"]} 0;
    overflow: hidden;
  }
`;

export const TitleButton = styled.button`
  position: relative;
  height: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  background-color: transparent;
  cursor: pointer;
  width: 100%;
  color: ${({ theme }) => theme.colorTokens.content.default};
  stroke: ${({ theme }) => theme.colorTokens.content.subtle};

  &:hover {
    color: ${({ theme }) => theme.colorTokens.content.link};
    stroke: ${({ theme }) => theme.colorTokens.content.link};
  }

  h3[data-qa-label="race-card-title"] {
    position: absolute;
    top: 0;
    left: 0;
    right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    margin-bottom: 0;
  }
`;

export const HiddenPlaceholderTitle = styled.div`
  height: 20px;
  overflow: hidden;
  visibility: hidden;
  pointer-events: none;
`;

export const OddsContainer = styled.div`
  ${flexColumn};
  align-items: flex-end;

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: center;
  }
`;

export const ScrLabelContainer = styled.div`
  padding-left: ${({ theme }) => theme.space["space-4"]};
  margin: auto 0;
`;

export const MLContainer = styled.div<{ isScratched?: boolean }>`
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
    `}
`;

export const JockeyTrainerContainer = styled.div<{ isScratched?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  ${({ isScratched }) =>
    isScratched &&
    css`
      opacity: 0.4;
      text-decoration: line-through;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    gap: 2px;
    flex-wrap: nowrap;
    width: 100%;
  }
`;

export const Entry = styled.span<{ hideEllipsis?: boolean }>`
  display: flex;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  margin: 2px 0;
  white-space: nowrap;

  /* Divider to show only on desktop */
  @media screen and ${breakpoints.tablet.min.sm} {
    &:not(:last-child) {
      border-right: 1px solid
        ${({ theme }) => theme.colorTokens.content.subtle3};
      margin-right: 4px;
      padding-right: 4px;
    }
  }

  ${({ hideEllipsis }) =>
    !hideEllipsis &&
    css`
      @media screen and ${breakpoints.tablet.max.sm} {
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        width: 100%;
      }
    `}
`;

export const BetButtonsContainer = styled.div<{ useUpdatedVisual?: boolean }>`
  display: inline-block;
  padding-left: ${({ theme }) => theme.space["space-4"]};
  margin: ${({ useUpdatedVisual }) => `${!useUpdatedVisual ? "0" : "auto 0"}`};
`;

export const AdvancedTextContainer = styled.div`
  display: flex;
  margin: 13px 0 0 62px;
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 15px;
`;

export const RightSideContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const InfoContainer = styled.div`
  ${flexColumn};
  text-align: center;
`;

export const OddsButton = styled.button<{
  isFavorite?: boolean;
  isSelected?: boolean;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 7px 10px;
  min-width: 60px;
  box-shadow: 0 1px 3px rgba(17, 43, 68, 0.12);
  border-radius: 2px;
  background: ${({ theme }) =>
    theme.colorTokens.component.button.secondary.content.base};
  border: 1px solid
    ${({ isFavorite, theme }) =>
      isFavorite
        ? theme.colorTokens.component.notification.promo.background
        : theme.colorTokens.component.button.tertiary.border.base};
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background: ${theme.colorTokens.component.button.secondary.background
        .hover};
      border-color: ${theme.colorTokens.component.button.tertiary.border
        .active};
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    height: 44px;
  }
`;

export const FavTagContainer = styled.div`
  display: inline-flex;
  position: absolute;
  top: -10px;
`;
